// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__2OV7P","fillColor":"IconSuccess_fillColor__373B8"};